export default function getUserRequestedAdSkip(state) {
  return state.ads.userRequestedAdSkip;
}
